import React, { useMemo } from 'react';
import { AttachmentList } from '@/components/attachment-list/attachment-list';
import { getImageHighlightsForEML, PROCESSED_STATUSES } from './utils';
import { OrderMetadata } from './types';

interface Props {
  onEmlError?: () => void;
  onHtmlHasNoContent?: () => void;
  onSelect?: (matchTerm: string) => void;
  order: OrderMetadata;
  selectedInputUUID?: string;
  showTranslation?: boolean;
}

export const OriginalInboundAttachments: React.FC<Props> = ({
  onEmlError,
  onHtmlHasNoContent,
  onSelect,
  order,
  selectedInputUUID,
  showTranslation,
}) => {
  const imageHighlights = useMemo(
    () => getImageHighlightsForEML(order),
    [order],
  );

  const showHighlights = !PROCESSED_STATUSES.has(order.status);

  return (
    <AttachmentList
      attachments={order.attachments!}
      imageHighlights={imageHighlights}
      onAreaSelect={(area) => onSelect?.(area.id)}
      onEmlError={onEmlError}
      onHighlightElementSelect={(searchInputUUID) =>
        onSelect?.(searchInputUUID)
      }
      onHtmlHasNoContent={onHtmlHasNoContent}
      orderUUID={order.smartOrderUUID}
      segments={order.segments}
      selectedAreaID={selectedInputUUID!}
      showHighlights={showHighlights}
      showTranslations={showTranslation}
    />
  );
};
